const Constants = require( '../../../server/constants' )

// This (Constant.js) file is used for maintaining constants variable through out the application
;(function (module) {
  'use strict'

  var apiUrl = 'https://obexwebtest.azurewebsites.net/',
    tenant = 'obex.onmicrosoft.com' //'cb454b68-a036-4dd5-a134-ebd4cdad4fe2'
  module
    .constant('obexConstant', {
      urlActivation: apiUrl + 'activations',
      urlCompleteActivation: apiUrl + 'activations/completerequest',
      urlOrganization: apiUrl + 'organizations',
      urlAccount: apiUrl + 'Members',
      urlBaseUrl: apiUrl,
      oauth2EndPoint: Constants.AUTH_TOKEN_URI,
      urlAgentPortal: 'https://us-sc-dev-agentportal-app.azurewebsites.net',
      obexWebResourceUri: 'http://obexweb.azurewebsites.net',
      clientId: 'd161d8a4-d704-4be6-82ba-3f5a14a306d5',
      urlTrips: apiUrl + 'trips',
      urlHotels: apiUrl + 'hotels',
      urlLimos: apiUrl + 'limos',
      urlGdsSettings: apiUrl + 'GdsSettings',
      urlGdsSettingsV2: apiUrl + 'v2/GdsSettings',
      urlCars: apiUrl + 'cars',
      urlFlights: apiUrl + 'flights',
      urlProfiles: apiUrl + 'profiles',
      urlTravelerTrack: apiUrl + 'TravelerTrack',
      urlTravelerCities: apiUrl + 'travelers',
      permissions: [
        'User',
        'TravelAgent',
        'TravelAgencyAdmin',
        'TravelManager',
        'ObexAdmin',
      ],
      urlTravelAgentOrganizations: apiUrl + 'TravelAgentOrganizations',
      urlTravelManagerOrganizations: apiUrl + 'TravelManagerOrganizations',
      urlSmsHistory: apiUrl + 'ChatMessages',
      urlPhoneHistory: apiUrl + 'PhoneLogs',
      urlTravelSpend: apiUrl + 'Reports',
      urlProvider: apiUrl + 'providers',
      urlCategory: apiUrl + 'v2/categories',
      urlApp: apiUrl + 'v2/apps',
      urlTripField: apiUrl + 'TripFields',
      urlAllowIntegrations: apiUrl + 'v2/allowintegrations',
      urlTripFieldOptions: apiUrl + 'TripFieldOptions',
      urlProfileFields: apiUrl + 'profilefields',
      urlProfileFieldOptions: apiUrl + 'ProfileFieldOptions',
      urlTravelers: apiUrl + 'members/travelers/',
      urlClients: apiUrl + 'organizations/clients',
      urlAgenciesClients: apiUrl + 'organizationchatapps/chatApp/OWA/travelAgencyid',
      urlAgencies: apiUrl + 'organizations/travelagencies',
      urlClientsFromAgency: apiUrl + 'organizations/travelagencyclients',
      urlCustomerAccount: apiUrl + 'CustomerAccounts',
      urlSsoOrganization: apiUrl + 'v2/ssoorganizations',
      urlSingleSignOn: apiUrl + 'v2/sso',
      urlWindowsTimeZones: apiUrl + 'windowstimezones',
      urlOrganizationProviders: apiUrl + 'OrganizationProviders',
      urlProcessPnr: apiUrl + 'v2/sabre',
      urlVirtualCardImage: apiUrl + 'conferma/deploymentid',
      urlGetConversation: apiUrl + 'v2/conversations',
      urlGetTopic: apiUrl + 'v2/topics/email',
      urlResetPassword: apiUrl + 'Activations/resetpassword/email',
      urlCsrfToken: apiUrl + 'csrf/csrftoken',
    })
    .constant('obexRoles', {
      roleUser: 0,
      roleTravelAgent: 1,
      roleTravelAgencyAdmin: 2,
      roleTravelManager: 3,
      roleObexAdmin: 4,
    })
    .constant('smsStatus', {
      Live: 0,
      FollowUp: 1,
      Transfer: 2,
      Finished: 3,
    })
})(angular.module('obex'))



// WEBPACK FOOTER //
// ./client/config/stage/obexConstant.js